/* Grid-level add-to-cart (quick-add chips) and the shared notify drawer.
   One delegated listener serves every card, including cards swapped in by
   facets or load-more. Adds go through Dotto.cartAdd, so the cart drawer
   opens itself with fresh sections — no extra wiring per card. */

document.addEventListener('click', async (event) => {
  const addChip = event.target.closest('[data-quick-add-variant]');
  if (addChip) {
    if (addChip.getAttribute('aria-disabled') === 'true') return;
    addChip.setAttribute('aria-disabled', 'true');
    try {
      await window.Dotto.cartAdd([{ id: parseInt(addChip.dataset.quickAddVariant, 10), quantity: 1 }]);
    } catch (error) {
      // Sold out between render and click: mark the chip honestly.
      addChip.classList.add('is-unavailable');
    } finally {
      addChip.removeAttribute('aria-disabled');
    }
    return;
  }

  const pairChip = event.target.closest('[data-add-pair]');
  if (pairChip) {
    if (pairChip.getAttribute('aria-disabled') === 'true') return;
    const ids = pairChip.dataset.addPair
      .split(',')
      .map((id) => parseInt(id, 10))
      .filter(Boolean);
    if (ids.length === 0) return;
    pairChip.setAttribute('aria-disabled', 'true');
    try {
      await window.Dotto.cartAdd(ids.map((id) => ({ id, quantity: 1 })));
    } finally {
      pairChip.removeAttribute('aria-disabled');
    }
    return;
  }

  const notifyChip = event.target.closest('[data-notify-trigger]');
  if (notifyChip) {
    const drawer = document.getElementById('NotifyDrawer');
    if (!drawer) return;
    const title = notifyChip.dataset.productTitle || '';
    const url = notifyChip.dataset.productUrl || '';
    const titleEl = drawer.querySelector('[data-notify-product-title]');
    const productInput = drawer.querySelector('[data-notify-product]');
    if (titleEl) titleEl.textContent = title;
    if (productInput) productInput.value = `${title} (${url})`;
    drawer.open(notifyChip);
  }
});
